<template>
  <div class="desktop">
    <div
      class="temp__flexbox temp__jc--c width--100p py--60 py--40--768 px--20"
    >
      <div class="intro mw--1120 px--40 height--100p video-border">
        <video
          class="temp__flexbox temp__jc--c width--100p mw--1120"
          id="video"
          role="presentation"
          preload="auto"
          playsinline
          crossorigin="anonymous"
          loop
          muted
          autoplay
        >
          <source
            class="width--100p mw--1120"
            src="lemonade-spritz-desktop.mp4"
            type="video/mp4"
          />
        </video>
        <div class="mute mute-desktop noselect">UNMUTE</div>
      </div>
    </div>
  </div>
  <div class="mobile">
    <div
      class="temp__flexbox temp__jc--c width--100p py--60 py--40--768 px--10"
    >
      <div class="intro mw--1120 px--40 height--100p video-border">
        <video
          class="temp__flexbox temp__jc--c width--100p mw--1120"
          id="video-mobile"
          role="presentation"
          preload="auto"
          playsinline
          crossorigin="anonymous"
          loop
          muted
          autoplay
        >
          <source
            class="width--100p mw--1120"
            src="lemonade-spritz-mobile.mp4"
            type="video/mp4"
          />
        </video>
        <div class="mute mute-mobile noselect">UNMUTE</div>
      </div>
    </div>
  </div>

  <div class="temp__flexbox temp__jc--c width--100p py--50">
    <img class="width--100p--768" src="hero/divider-gold.png" />
  </div>
  <div class="temp__flexbox temp__jc--c width--100p pt--40">
    <div class="title mp--m mw--1120 px--40">explore our range</div>
  </div>
</template>

<script setup>
import dataModel from "../js/model.js";
const props = defineProps({
  brandExperience: {
    type: String,
    default: "1",
  },
});

$(document).ready(function () {
  $("#video").prop("muted");
  $("#video-mobile").prop("muted");
  $(".mute-desktop").click(function () {
    if ($("#video").prop("muted")) {
      $(this).prev("#video").prop("muted", false);
      $(this).html("MUTE");
      $(this).css({ background: "#000000" });
    } else {
      $(this).prev("#video").prop("muted", true);
      $(this).html("UNMUTE");
      $(this).css({ background: "#bc0e2d" });
    }
  });
  $(".mute-mobile").click(function () {

    if ($("#video-mobile").prop("muted")) {
      $(this).prev("#video-mobile").prop("muted", false);
      $(this).html("MUTE");
      $(this).css({ background: "#000000" });
    } else {
      $(this).prev("#video-mobile").prop("muted", true);
      $(this).html("UNMUTE");
      $(this).css({ background: "#bc0e2d" });
    }
  });
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.intro {
  position: relative;
}
.mute {
  @include flexbox();
  @include align-items(center);
  @include justify-content(center);
  position: absolute;
  top: 20px;
  left: 20px;
  font-family: "Mark Pro", sans-serif;
  background: #bc0e2d;
  height: 40px;
  width: 100px;
  border-radius: 40px;
  color: #ffffff;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 1px;
}
.video-border {
  border: solid 2px #bc0e2d;
  padding: 10px;
}

.height--100p {
  height: 100%;
}

.mp--b {
  font-family: "Mark Pro";
  font-weight: bold;
  text-transform: uppercase;
}

.title {
  font-size: 40px;
  color: $color--smirnoff;
  @media (max-width: 750px) {
    font-size: 34px;
  }
}

.mp--m {
  font-family: "Mark Pro";
  font-weight: 500;
  text-transform: uppercase;
}
.desktop {
  height: auto;
  @media screen and (max-width: 600px) {
    display: none;
  }
}
.mobile {
  display: none;

  @media screen and (max-width: 600px) {
    display: block;
  }
}
</style>